import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-4 py-6 sm:py-16 items-center justify-center min-h-[100dvh] sm:min-h-0" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #001a2d 30%, #000d1a 60%, #0a0a0a 100%)'
  }} data-id="element-131">
      {/* Logo */}
      <div className="mb-2 sm:mb-3" data-id="element-132">
        <span className="text-[#00B4D8] text-xl sm:text-2xl font-black tracking-widest" data-id="element-133">
          🎾 PROFEPACK
        </span>
      </div>

      {/* Social proof badge */}
      <div className="mb-3 sm:mb-5" data-id="element-134">
        <span className="inline-flex items-center gap-2 bg-white/10 border border-[#00B4D8]/30 text-white text-xs sm:text-sm font-semibold px-4 py-1.5 rounded-full backdrop-blur-sm" data-id="element-135">
          <span className="relative flex h-2 w-2" data-id="element-136">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-137"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-138"></span>
          </span>
          +300 profes en Argentina ya lo usan
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-5xl text-3xl sm:text-5xl md:text-7xl lg:text-8xl mb-2 leading-tight" data-id="element-139">
        Todo tu año de Tenis
        <br data-id="element-140" />
        <span className="text-[#00B4D8]" data-id="element-141">resuelto.</span>
      </h1>

      {/* Pain-agitation subhead */}
      <p className="text-gray-400 text-sm sm:text-lg max-w-xl mb-4 sm:mb-5 leading-snug" data-id="element-142">
        Dejá de improvisar clases y perder domingos planificando.
      </p>

      {/* Mockup image — LCP element */}
      <div className="w-full max-w-[200px] sm:max-w-[280px] md:max-w-[340px] mx-auto mb-4 sm:mb-4" style={{
      aspectRatio: '1/1'
    }} data-id="element-143">
        <img src="https://cdn.magicpatterns.com/uploads/kaz1Mr6qjahPu83gAh3XKa/Coordinacion_(6).png" alt="PROFEPACK MegaPack Tenis Listo — Combo Completo" className="w-full h-full object-contain drop-shadow-[0_0_30px_rgba(0,180,216,0.25)]" width={340} height={340} fetchPriority="high" data-id="element-144" />
      </div>

      {/* Value proposition */}
      <p className="text-white font-bold sm:text-xl max-w-2xl mb-1 text-[15px]" data-id="element-145">
        6 tomos + 6 bonos + sistema "Abrir y Dictar"
      </p>
      <p className="text-gray-400 text-[11px] sm:text-sm max-w-lg mb-3 sm:mb-4" data-id="element-146">
        Clases · Técnica · Táctica · Drills · Gestión · Negocio — todo en PDF,
        listo para usar mañana.
      </p>

      {/* Urgency anchor */}
      <p className="text-[#FF0000] text-xs sm:text-sm font-bold mb-3 blink" data-id="element-147">
        🔥 Precio de lanzamiento — cupos limitados
      </p>

      {/* CTA Button */}
      <a href="#pricing" className="btn-green-pulse bg-[#00B4D8] font-black text-base sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#38BDF8] transition-colors inline-block mb-2 w-full sm:w-auto max-w-sm text-white" data-id="element-148">
        👉 VER PLANES Y EMPEZAR HOY
      </a>

      {/* Micro-commitment reassurance */}
      <p className="text-gray-500 text-[11px] sm:text-xs mb-3 sm:mb-4" data-id="element-149">
        Acceso de por vida · Sin suscripción · Descargás y listo
      </p>

      {/* Trust badges */}
      <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-gray-300 text-[11px] sm:text-sm" data-id="element-150">
        <span data-id="element-151">🛡️ Garantía 7 días</span>
        <span className="hidden sm:inline text-gray-600" data-id="element-152">|</span>
        <span data-id="element-153">🔒 Pago seguro</span>
        <span className="hidden sm:inline text-gray-600" data-id="element-154">|</span>
        <span data-id="element-155">💳 Mercado Pago · Tarjeta · Transferencia</span>
      </div>
    </section>;
}